import { axiosRequest } from '@/util/axios-request'

// 解散公司
export const dismissCompany = data => {
  return axiosRequest({
    url: '/web/company/dismiss',
    data
  })
}

// 更换主管理员
export const transfer = data =>
  axiosRequest({
    url: '/web/company/transfer',
    data
  })

// 获取公司信息
export const getCompanyInfo = data => {
  return axiosRequest({
    url: '/web/company/info',
    data
  })
}

// 获取企业邀请码
export const getCode = data => {
  return axiosRequest({
    url: '/web/invite/getcode',
    data
  })
}
// 更新企业邀请码
export const getCreateCode = data => {
  return axiosRequest({
    url: '/web/invite/createcode',
    data
  })
}

// 申请人列表
export const getPendingList = data => {
  return axiosRequest({
    url: '/web/invite/pendingList',
    data
  })
}
// 激活码开关
export const switchstate = data => {
  return axiosRequest({
    url: '/web/invite/switchstate',
    data
  })
}

// 权限资源列表
export const recouseList = data => {
  return axiosRequest({
    url: '/web/resource/list',
    data
  })
}

// 创建权限组
export const createGroup = data => {
  return axiosRequest({
    url: '/web/privilege_group/create',
    data
  })
}

// 权限组更新
export const modifyGroup = data => {
  return axiosRequest({
    url: '/web/privilege_group/update',
    data
  })
}
// 权限组信息
export const groupInfo = data => {
  return axiosRequest({
    url: '/web/privilege_group/info',
    data
  })
}
// 权限组列表
export const groupList = data => {
  return axiosRequest({
    url: '/web/privilege_group/list',
    data
  })
}
// 删除权限组
export const remove = data => {
  return axiosRequest({
    url: '/web/privilege_group/remove',
    data
  })
}

// 权限组员工列表
export const groupStaffList = data => {
  return axiosRequest({
    url: '/web/privilege_group/staffList',
    data
  })
}
// 权限组添加成员
export const addStaff = data =>
  axiosRequest({
    url: '/web/privilege_group/addStaff',
    data
  })

// 权限组移除员工
export const removeStaff = data =>
  axiosRequest({
    url: '/web/privilege_group/removeStaff',
    data
  })

// 更改公司信息
export const modifybase = data =>
  axiosRequest({
    url: '/web/company/update',
    data
  })

// 审批同意加入 待办同意、屏蔽、拒绝
export const inviteApproval = data =>
  axiosRequest({
    url: '/web/invite/approval',
    data
  })

// 内容列表
export const cmsGetList = () =>
  axiosRequest({
    url: '/web/cms/getList',
    methods: 'get'
  })

// 内容子列表和详情
export const cmsGetsubList = params =>
  axiosRequest({
    url: '/web/cms/getsubList',
    methods: 'get',
    params
  })

// 内容详情
export const cmsGetContent = params =>
  axiosRequest({
    url: '/web/cms/getContent',
    methods: 'get',
    params
  })

// 获取可见列枚举项
export const getdepartmentvisitcolumn = () =>
  axiosRequest({
    url: '/web/organization/getdepartmentvisitcolumn',
    methods: 'get'
  })
// 获取部门可见性
export const getdepartmentvisit = () =>
  axiosRequest({
    url: '/web/organization/getdepartmentvisit',
    methods: 'get'
  })
// 设置部门可见性
export const setdepartmentvisit = params =>
  axiosRequest({
    url: '/web/organization/setdepartmentvisit',
    params
  })

// 企业认证存储
export const saveAudit = params => axiosRequest({ url: '/web/company/saveAudit', params })
// 设置全局水印
export const setglobalwatermark = params =>
  axiosRequest({
    url: '/web/company/setglobalwatermark',
    params
  })

// 获取全局水印
export const getglobalwatermark = params =>
  axiosRequest({
    url: '/web/company/getglobalwatermark',
    params
  })
// 获取全局水印
export const getSecuritySetting = params =>
  axiosRequest({
    url: '/web/company/getSecuritySetting',
    method: 'get',
    params
  })
// 获取全局水印
export const setSecuritySetting = params =>
  axiosRequest({
    url: '/web/company/setSecuritySetting',
    params
  })

// 设置自动停职/离职设置接口
export const setAutoSuspensionResign = data =>
  axiosRequest({
    url: '/web/company/setAutoSuspensionResign',
    data
  })

// 获取自动停职/离职设置接口
export const getAutoSuspensionResign = data =>
  axiosRequest({
    url: '/web/company/getAutoSuspensionResign',
    data
  })

// 获取自动停职/离职设置接口
export const agreementSave = data =>
  axiosRequest({
    url: '/web/privacy_agreement/save',
    data
  })
//
export const getAgreement = data =>
  axiosRequest({
    url: '/web/privacy_agreement/info',
    data
  })

// 权限组员工列表
export const managerList = data => {
  return axiosRequest({
    url: '/web/privilege_manager/list',
    data
  })
}

// 获取管理人权限信息
export const managerInfo = data => {
  return axiosRequest({
    url: '/web/privilege_manager/info',
    data
  })
}

// 获取管理人权限信息
export const managerCreate = data => {
  return axiosRequest({
    url: '/web/privilege_manager/create',
    data
  })
}

// 获取管理人权限信息
export const managerEdit = data => {
  return axiosRequest({
    url: '/web/privilege_manager/edit',
    data
  })
}

// 删除管理人权限
export const managerDelete = data => {
  return axiosRequest({
    url: '/web/privilege_manager/delete',
    data
  })
}

// 获取管理人权限信息
export const checkSettingRelation = data => {
  return axiosRequest({
    url: '/web/attendance/check_setting_relation',
    data
  })
}
